/**
 * @Author: shenyi
 * @Date:   2023-08-11 17:46:23
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-08-13 12:57:07
 */
import HttpRequest from './axios'
import Qs from 'qs'

const baseUrl = process.env.REACT_APP_ENV === 'production' ? 'https://prod-api.dbxiao.com' :(process.env.REACT_APP_ENV === 'test' ? 'https://api-test.dbxiao.cn': '') 
let groupId = ''
if (window.location.search) {
    let params = Qs.parse(window.location.search.split('?')[1])
    groupId = params.system_partition_gId ? String(params.system_partition_gId): ''
}
const axios = new HttpRequest(baseUrl, groupId)
export default axios